document.addEventListener("DOMContentLoaded", () => {
	initSidebarOffset();
});
window.addEventListener("resize", () => {
	initSidebarOffset();
});

function initSidebarOffset() {
	let sidebar = document.querySelector("aside.sidebar");
	let intro = document.querySelector(".intro-section");
	if (!sidebar || !intro) return;

	if (window.innerWidth > 991) {
		if (intro.classList.contains("intro-type-image-large")) {
			let bgHeight = 360;
			let offset = 12;
			sidebar.style.marginTop = Math.round(intro.getBoundingClientRect().height) * -1 + bgHeight + offset + "px";
		}
		if (intro.classList.contains("intro-type-review")) {
			let bgHeight = 274;
			let offset = 30;
			sidebar.style.marginTop = Math.round(intro.getBoundingClientRect().height) * -1 + bgHeight + offset + "px";
		}
	} else {
		sidebar.style.marginTop = "";
	}
}
